var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseMenuIcon = function SvgCloseMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    style: {
      pointerEvents: "none"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "m17.887 16 7.057-7.058a1.33 1.33 0 0 0 0-1.885 1.33 1.33 0 0 0-1.885 0l-7.057 7.057-7.058-7.057a1.33 1.33 0 0 0-1.885 0 1.33 1.33 0 0 0 0 1.885L14.116 16 7.06 23.057a1.332 1.332 0 0 0 .943 2.276c.341 0 .682-.13.942-.39l7.058-7.058 7.057 7.057a1.33 1.33 0 0 0 1.885 0 1.33 1.33 0 0 0 0-1.885z",
    clipRule: "evenodd"
  })));
};
export default SvgCloseMenuIcon;